import menuBtn from './assets/menu_btn.js'
menuBtn()

import menuDropdown from './assets/menu_dropdown.js'
menuDropdown()

import anchorLink from './assets/anchorLink.js'
anchorLink({
  speed: 1000,
  offset: true
})
